import type { CommercialState } from "@/domain/types";

type RecordValue = Record<string, unknown>;
function record(value: unknown): RecordValue | null {
  return value && typeof value === "object" && !Array.isArray(value)
    ? (value as RecordValue)
    : null;
}

export function parseCommercial(value: unknown): CommercialState | null {
  const commercial = record(value);
  const type = commercial?.["type"];
  const accessStatus = commercial?.["accessStatus"];
  return (type === "standard" || type === "design_partner") &&
    (accessStatus === "inactive" || accessStatus === "active" || accessStatus === "suspended")
    ? { type, accessStatus }
    : null;
}

export function isActiveManager(value: unknown): boolean {
  const member = record(value);
  return member?.["role"] === "manager" && member["status"] === "active";
}

export function isManagementEligible(value: unknown): boolean {
  const account = record(value);
  if (!account) return false;
  const commercial = parseCommercial(account["commercial"]);
  return (
    account["status"] === "active" &&
    commercial?.type === "design_partner" &&
    commercial.accessStatus === "active"
  );
}

export function currentManagerUid(value: unknown): string | null {
  const management = record(record(value)?.["management"]);
  const uid = management?.["currentManagerUid"];
  return typeof uid === "string" && uid.trim() === uid && uid.length > 0 ? uid : null;
}

export function hasManagementProtection(value: unknown): boolean {
  const management = record(value)?.["management"];
  if (management == null) return false;
  const data = record(management);
  // Establishment and legacy metadata protect historical accounts, including
  // records without a usable timestamp. Null assignment alone is not history.
  return (
    !data ||
    data["establishedAt"] != null ||
    data["currentManagerUid"] != null ||
    Object.keys(data).some((key) => key !== "currentManagerUid" && key !== "establishedAt")
  );
}

export function isProtectedAcquisitionAccount(value: unknown): boolean {
  return hasManagementProtection(value);
}
